import { alpha, type Theme } from '@mui/material/styles';

/** The class a row's floating actions carry, so the row can reveal them. */
export const HOVER_ACTIONS = 'stack-builder-hover-actions';

/** On the row: show its actions while it is hovered or something in it has keyboard focus. */
export const revealHoverActions = {
  [`&:hover .${HOVER_ACTIONS}, &:focus-within .${HOVER_ACTIONS}`]: { opacity: 1, pointerEvents: 'auto' },
} as const;

/**
 * A row's buttons, floated over its right end on a frosted strip instead of taking a column of
 * their own, so the name and badges get the row's full width until the row is hovered. The row
 * must be `position: relative`. Without hover (touch screens) there is nothing to reveal them,
 * so they sit in the row as ordinary buttons.
 */
export const hoverActionsSx = (theme: Theme) => ({
  position: 'absolute' as const,
  right: 4,
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  alignItems: 'center',
  gap: 0.25,
  // Even padding and a pill radius follow the round icon buttons: a circle around a single
  // button (the library's +), a pill around a row of them.
  p: 0.25,
  borderRadius: 999,
  bgcolor: theme.vars
    ? `rgba(${theme.vars.palette.background.paperChannel} / 0.72)`
    : alpha(theme.palette.background.paper, 0.72),
  backdropFilter: 'blur(6px)',
  boxShadow: theme.shadows[2],
  opacity: 0,
  pointerEvents: 'none' as const,
  transition: theme.transitions.create('opacity', { duration: 120 }),
  '@media (hover: none)': {
    position: 'static' as const,
    transform: 'none',
    opacity: 1,
    pointerEvents: 'auto' as const,
    bgcolor: 'transparent',
    backdropFilter: 'none',
    boxShadow: 'none',
    p: 0,
  },
});
